import { AppText } from '@otomoro/components/shared/AppText'
import { AppTitle } from '@otomoro/components/shared/AppTitle'
import { PortableText, PortableTextComponents } from 'next-sanity'
import { PortableTextObject } from 'sanity'
import { contentBlocksClasses, ContentBlocksVariants } from './ContentBlocks.css'
import { AppList } from '../AppList'
import { SectionHeader } from '../SectionHeader'

interface ContentBlocksProps extends ContentBlocksVariants {
	tag: string
	title: PortableTextObject
	description: PortableTextObject
	blocks: any[]
	offset: boolean
	fullWidth: boolean
}

export const ContentBlocks: React.FC<ContentBlocksProps> = ({
	title,
	description,
	blocks,
	tag,
	offset,
	fullWidth,
}) => {
	const { base, grid, emptyTextCell, textCell, bodyText, listStyle, listItemStyle, listItemText } =
		contentBlocksClasses()

	const titleComponents = {
		block: {
			normal: ({ children }: any) => (
				<AppTitle as="h3" textTransform="uppercase" variant="h3" color="black">
					{children}
				</AppTitle>
			),
		},
		marks: {
			highlight: ({ children }: any) => <span className="text-mainPink">{children}</span>,
		},
	} as PortableTextComponents

	const bodyComponents = {
		block: {
			normal: ({ children }: any) => (
				<AppText as="p" size="small" color="black" className={bodyText()}>
					{children}
				</AppText>
			),
		},
		list: {
			bullet: ({ children }) => <ul>{children}</ul>,
		},
		listItem: {
			bullet: ({ children }) => (
				<li>
					<AppText size="small">{children}</AppText>
				</li>
			),
		},
		marks: {
			highlight: ({ children }: any) => <span className="text-mainPink">{children}</span>,
		},
	} as PortableTextComponents

	return (
		<section className={base()}>
			{title && (
				<SectionHeader tag={tag} title={title} description={description} fullWidth={fullWidth} />
			)}
			<div className={grid({ mt: title !== undefined })}>
				{offset && <div className={emptyTextCell()}></div>}
				{blocks &&
					blocks.map((block, index) => {
						if (!offset && blocks.length % 3 === 2 && index === blocks.length - 2) {
							return (
								<>
									<div key={index} className={emptyTextCell()}></div>
									<div key={index} className={textCell()}>
										<PortableText value={block.title} components={titleComponents} />
										<div className="mt-1 prose">
											<PortableText value={block.body} components={bodyComponents} />
										</div>
									</div>
								</>
							)
						}
						return (
							<div key={index} className={textCell()}>
								<PortableText value={block.title} components={titleComponents} />
								<div className="mt-1 prose">
									<PortableText value={block.body} components={bodyComponents} />
								</div>
							</div>
						)
					})}
			</div>
		</section>
	)
}
